export const PRODUCT_APPROVAL_NO = 9;
export const PRODUCT_APPROVAL_YES = 1;
export const PRODUCT_APPROVAL_INREVIEW = 2;

export const productApprovalFormat = val => {
    switch (val) {
        case PRODUCT_APPROVAL_NO:
            return '未通过';
        case PRODUCT_APPROVAL_YES:
            return '通过';
        case PRODUCT_APPROVAL_INREVIEW:
            return '审核中';
    }

    return '';
};

export const productApprovalColor = val => {
    switch (val) {
        case PRODUCT_APPROVAL_NO:
            return 'error';
        case PRODUCT_APPROVAL_YES:
            return 'success';
        case PRODUCT_APPROVAL_INREVIEW:
            return 'warning';
    }

    return '';
};
